export default {"src":"https://s.sylndr.com/c-fd0c3a5/_next/static/media/path2ThankYou.d637f3d7.svg","height":229,"width":329,"blurWidth":0,"blurHeight":0};